import { render, staticRenderFns } from "./classDetail2.vue?vue&type=template&id=3c8312b3&scoped=true"
import script from "./classDetail2.vue?vue&type=script&lang=js"
export * from "./classDetail2.vue?vue&type=script&lang=js"
import style0 from "./classDetail2.vue?vue&type=style&index=0&id=3c8312b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8312b3",
  null
  
)

export default component.exports